import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-188748bb")

_pushScopeId("data-v-188748bb")
const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "flex top-button-group" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "发放项目", -1)
const _hoisted_4 = { class: "cascader" }
const _hoisted_5 = { class: "order-status flex" }
const _hoisted_6 = { class: "flex button-group flexC alignC" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "c-60" }, "详情", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "c-60" }, "退款", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "c-60" }, "拒绝", -1)
const _hoisted_10 = { class: "flex flexR mar-t-22" }
const _hoisted_11 = { class: "flex flexSb alignC mar-b-20" }
const _hoisted_12 = { class: "c-red f-16" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "c-60" }, "打印订单", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "c-60" }, "上一个订单", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "c-60" }, "下一个订单", -1)
const _hoisted_17 = {
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_18 = { class: "dialog-order" }
const _hoisted_19 = { class: "dialog-nav flex" }
const _hoisted_20 = { class: "order-detail" }
const _hoisted_21 = {
  key: 0,
  class: "mar-b-16"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("span", { class: "c-30 text-right" }, "优惠券：", -1)
const _hoisted_23 = { class: "c-30" }
const _hoisted_24 = {
  key: 1,
  class: "mar-b-16"
}
const _hoisted_25 = /*#__PURE__*/_createVNode("span", { class: "c-30 text-right" }, "尊享卡：", -1)
const _hoisted_26 = { class: "c-30" }
const _hoisted_27 = { class: "mar-b-16" }
const _hoisted_28 = /*#__PURE__*/_createVNode("span", { class: "c-30 text-right" }, "支付方式：", -1)
const _hoisted_29 = { class: "c-30" }
const _hoisted_30 = { class: "mar-b-16" }
const _hoisted_31 = /*#__PURE__*/_createVNode("span", { class: "c-30 text-right" }, "付款时间：", -1)
const _hoisted_32 = { class: "c-30" }
const _hoisted_33 = { class: "mar-b-16" }
const _hoisted_34 = /*#__PURE__*/_createVNode("span", { class: "c-30 text-right" }, "实付款：", -1)
const _hoisted_35 = { class: "c-30" }
const _hoisted_36 = { class: "code-check" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = /*#__PURE__*/_createVNode("span", { class: "c-ff w-500" }, "确认核销", -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("p", { class: "c-90 w-500" }, " 温馨提示： 输入客户订单详情上的核销码 ", -1)
const _hoisted_40 = {
  key: 1,
  class: "c-90 w-500"
}
const _hoisted_41 = { class: "dialog-back absolute flex flexR bg-f2" }
const _hoisted_42 = /*#__PURE__*/_createVNode("span", { class: "c-ff w-500" }, "返回", -1)
const _hoisted_43 = { class: "" }
const _hoisted_44 = { class: "flex" }
const _hoisted_45 = { class: "flex" }
const _hoisted_46 = { class: "dialog-footer" }
const _hoisted_47 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "提交", -1)
const _hoisted_48 = /*#__PURE__*/_createTextVNode("取 消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_cascader = _resolveComponent("el-cascader")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _directive_loading = _resolveDirective("loading")
  const _directive_print = _resolveDirective("print")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.roleList.give_out)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            class: "bg-red",
            onClick: _ctx.addCard
          }, {
            default: _withId(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_input, {
        modelValue: _ctx.screen.search,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.screen.search = $event)),
        class: "search-input",
        clearable: "",
        "suffix-icon": "el-icon-search",
        placeholder: "订单编号/会员号/手机号",
        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.screenChange($event, 'search')))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        modelValue: _ctx.screen.time,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.screen.time = $event)),
        type: "daterange",
        align: "right",
        "unlink-panels": "",
        "range-separator": "-",
        "start-placeholder": "开始日期",
        "end-placeholder": "结束日期",
        shortcuts: _ctx.shortcuts,
        onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.screenChange($event, 'time')))
      }, null, 8, ["modelValue", "shortcuts"]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_el_cascader, {
          modelValue: _ctx.screen.service,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.screen.service = $event)),
          clearable: "",
          options: _ctx.project,
          props: {
                        expandTrigger: 'hover',
                        label: 'name',
                        value: 'id',
                    },
          placeholder: "选择服务",
          onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.screenChange($event, 'service')))
        }, null, 8, ["modelValue", "options"])
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orderStatusNav, (item, index) => {
        return (_openBlock(), _createBlock("p", {
          class: ["mar-r-20", { 'nav-range c-red': index == _ctx.orderStatus }],
          key: index,
          onClick: ($event: any) => (_ctx.orderStatus = index)
        }, _toDisplayString(item.name), 11, ["onClick"]))
      }), 128))
    ]),
    _withDirectives(_createVNode(_component_el_table, {
      data: _ctx.tableData,
      stripe: "",
      style: {"width":"100%"},
      class: "table",
      "header-cell-style": _ctx.headClass
    }, {
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            align: "center",
            prop: item.prop,
            label: item.label,
            "min-width": item.width,
            key: index
          }, null, 8, ["prop", "label", "min-width"]))
        }), 128)),
        _createVNode(_component_el_table_column, {
          label: "操作",
          align: "center",
          "min-width": "200"
        }, {
          default: _withId((scope) => [
            _createVNode("div", _hoisted_6, [
              (_ctx.roleList.detail)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    onClick: ($event: any) => (_ctx.columnChange(scope.row, 0))
                  }, {
                    default: _withId(() => [
                      _hoisted_7
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (scope.row.status == -2 && _ctx.roleList.refund)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    onClick: ($event: any) => (_ctx.columnChange(scope.row, 2))
                  }, {
                    default: _withId(() => [
                      _hoisted_8
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (scope.row.status == -2 && _ctx.roleList.refuse)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 2,
                    onClick: ($event: any) => (_ctx.columnChange(scope.row, 3))
                  }, {
                    default: _withId(() => [
                      _hoisted_9
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "header-cell-style"]), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode("div", _hoisted_10, [
      _createVNode(_component_el_pagination, {
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange,
        "current-page": _ctx.currentPage,
        "page-sizes": [10, 20,50,100],
        "page-size": _ctx.pageSize,
        layout: "total, sizes, prev, pager, next, jumper",
        total: _ctx.total
      }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      title: "订单详情",
      width: "1000px",
      modelValue: _ctx.dialogFormVisible,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.dialogFormVisible = $event)),
      center: ""
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_11, [
          _createVNode("p", _hoisted_12, " 订单号：" + _toDisplayString(_ctx.orderDetail.ordersn) + " 【" + _toDisplayString(_ctx.orderDetail.pay_status_text) + "】 ", 1),
          (_ctx.orderDetail.status == 2)
            ? (_openBlock(), _createBlock("div", _hoisted_13, [
                _withDirectives(_createVNode(_component_el_button, null, {
                  default: _withId(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }, 512), [
                  [_directive_print, '#printTest']
                ]),
                _createVNode(_component_el_button, {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.columnChange(_ctx.scope.row, true)))
                }, {
                  default: _withId(() => [
                    _hoisted_15
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.columnChange(_ctx.scope.row, true)))
                }, {
                  default: _withId(() => [
                    _hoisted_16
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("table", _hoisted_17, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailTable, (items, index) => {
            return (_openBlock(), _createBlock("tr", { key: index }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(items, (item, idx) => {
                return (_openBlock(), _createBlock("td", { key: idx }, _toDisplayString(item), 1))
              }), 128))
            ]))
          }), 128))
        ]),
        _createVNode("div", _hoisted_18, [
          (_ctx.orderDetail.status != 0)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _createVNode("div", _hoisted_19, [
                  _createVNode("p", {
                    class: ["mar-r-20 w-500", { 'c-red nav-range': _ctx.dialogNavIndex == 0 }],
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.dialogNavIndex = 0))
                  }, " 付款信息 ", 2),
                  (_ctx.orderDetail.status > 0)
                    ? (_openBlock(), _createBlock("p", {
                        key: 0,
                        class: ["w-500", { 'c-red nav-range': _ctx.dialogNavIndex == 1 }],
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.dialogNavIndex = 1))
                      }, " 订单核销 ", 2))
                    : _createCommentVNode("", true)
                ]),
                _withDirectives(_createVNode("div", _hoisted_20, [
                  (_ctx.orderDetail.reduce_price)
                    ? (_openBlock(), _createBlock("p", _hoisted_21, [
                        _hoisted_22,
                        _createVNode("span", _hoisted_23, " -¥" + _toDisplayString(_ctx.orderDetail.reduce_price), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.orderDetail.vipcard_name)
                    ? (_openBlock(), _createBlock("p", _hoisted_24, [
                        _hoisted_25,
                        _createVNode("span", _hoisted_26, _toDisplayString(_ctx.orderDetail.vipcard_name), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("p", _hoisted_27, [
                    _hoisted_28,
                    _createVNode("span", _hoisted_29, _toDisplayString(_ctx.orderDetail.pay_type_text), 1)
                  ]),
                  _createVNode("p", _hoisted_30, [
                    _hoisted_31,
                    _createVNode("span", _hoisted_32, _toDisplayString(_ctx.orderDetail.pay_time), 1)
                  ]),
                  _createVNode("p", _hoisted_33, [
                    _hoisted_34,
                    _createVNode("span", _hoisted_35, _toDisplayString(_ctx.orderDetail.payment), 1)
                  ])
                ], 512), [
                  [_vShow, _ctx.dialogNavIndex == 0]
                ]),
                _withDirectives(_createVNode("div", _hoisted_36, [
                  (_ctx.orderDetail.nucleus_pin_code_status == 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_37, [
                        _createVNode(_component_el_form, {
                          model: _ctx.orderDetail,
                          "status-icon": "",
                          rules: _ctx.rules,
                          ref: "formRef",
                          "label-position": "left",
                          "label-width": "100px",
                          class: "mar-b-20 check"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, {
                              label: "核销码：",
                              prop: "check"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  type: "text",
                                  modelValue: _ctx.orderDetail.nucleus_pin_code,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.orderDetail.nucleus_pin_code = $event)),
                                  placeholder: "请输入核销码"
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_el_button, {
                                  class: "bg-red",
                                  onClick: _ctx.check
                                }, {
                                  default: _withId(() => [
                                    _hoisted_38
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model", "rules"]),
                        _hoisted_39
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.orderDetail.nucleus_pin_code_status == 1)
                    ? (_openBlock(), _createBlock("div", _hoisted_40, " 该订单已核销完成，核销码为" + _toDisplayString(_ctx.orderDetail.nucleus_pin_code), 1))
                    : _createCommentVNode("", true)
                ], 512), [
                  [_vShow, _ctx.dialogNavIndex == 1]
                ])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_41, [
          _createVNode(_component_el_button, {
            class: "bg-red",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.dialogFormVisible = false))
          }, {
            default: _withId(() => [
              _hoisted_42
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "发放项目",
      modelValue: _ctx.dialog_show,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.dialog_show = $event)),
      center: "",
      width: 1000
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_46, [
          _createVNode(_component_el_button, {
            class: "bg-red",
            onClick: _ctx._formSubmit
          }, {
            default: _withId(() => [
              _hoisted_47
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.dialog_show = false))
          }, {
            default: _withId(() => [
              _hoisted_48
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _createVNode("div", _hoisted_43, [
          _createVNode(_component_el_form, {
            ref: "projectFormRef",
            model: _ctx.projectForm,
            rules: _ctx.projectRules,
            "label-width": "100px"
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_44, [
                _createVNode(_component_el_form_item, {
                  label: "用户手机号",
                  prop: "phone"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.projectForm.phone,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.projectForm.phone = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "选择项目",
                  prop: "project_id"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.projectForm.project_id,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.projectForm.project_id = $event)),
                      placeholder: "请选择",
                      clearable: "",
                      filterable: ""
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.projectList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "发放次数",
                  prop: "number"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      type: "number",
                      modelValue: _ctx.projectForm.number,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.projectForm.number = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createVNode("div", _hoisted_45, [
                _createVNode(_component_el_form_item, { label: "赠送成本" }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "赠送的项目才需要填成本",
                      modelValue: _ctx.projectForm.cost_price,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.projectForm.cost_price = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "成本承担部门" }, {
                  default: _withId(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.projectForm.branch_id,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.projectForm.branch_id = $event)),
                      placeholder: "请选择",
                      clearable: "",
                      filterable: ""
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.branchList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
})